export const locale = {
    lang: "en-US",
    data: {
        BILLING: {
            TITLE: "Billing",
            LOADING: "Loading...",
            SHOW_MORE: "Show more",
            INVOICE: "Invoice",
            BANK_SLIP: "Bank Slip",
            CREDIT_CARD: "Credit Card",
            PIX: "PIX",
            COUPON: "Coupon",
            REVIEW_NOTE: "If the transaction was rejected by the card operator, try making the purchase again.",
            STATUS: {
                PENDING: "Pending",
                BILLED: "Paid",
                EXTERNALLY_PAID: "Externally Paid",
                CANCELED: "Canceled",
                EXPIRED: "Expired",
                DUE: "Due",
                REVIEW: "Review"
            }
        }
    }
};